import { ModalContent, ModalFooter } from '@components/modal';

const CancelHelpModal = ({ cancelClick }) => (
  <ModalContent title='Confirm Cancellation'>
    <section className='modal-body'>
      <div>
        <p>Are you sure you want to cancel your open help inquiry for this request?</p>
      </div>
    </section>
    <ModalFooter onSave={() => cancelClick()} saveText='Yes' cancelText='No' onCancel={() => {}} />
  </ModalContent>
);

export default CancelHelpModal;
